import { render, staticRenderFns } from "./EditarEventoView.vue?vue&type=template&id=167fd3a0"
import script from "./EditarEventoView.vue?vue&type=script&lang=js"
export * from "./EditarEventoView.vue?vue&type=script&lang=js"
import style0 from "./EditarEventoView.vue?vue&type=style&index=0&id=167fd3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports